import React, { useState } from "react";
import useSupplierTransaction from "../../hooks/useSupplierTransaction";
import SupplierBalances from "./SupplierBalances";
import SupplierTable from "./SupplierTable";
import SupplierFormModal from "./SupplierFormModal";
import styles from "./SupplierTab.module.css";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";

const SupplierTab = () => {
  const {
    items,
    balances,
    filters,
    pagination,
    loading,
    updateFilters,
    goToPage,
    addItem,
    editItem,
    deleteItem,
  } = useSupplierTransaction();

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const openAddModal = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const openEditModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const handleSubmit = async (payload, setFieldError) => {
    if (selectedItem) {
      await editItem(selectedItem.id, payload, setFieldError);
    } else {
      await addItem(payload, setFieldError);
    }
  };

  const requestDelete = (item) => setItemToDelete(item);
  const cancelDelete = () => {
    if (deleting) return;
    setItemToDelete(null);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    setDeleting(true);
    try {
      await deleteItem(itemToDelete.id);
      setItemToDelete(null);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className={styles.wrapper} dir="rtl">
      <SupplierBalances balances={balances} />

      <div className={styles.toolbar}>
        <div className={styles.filters}>
          <input
            type="text"
            placeholder="اسم المورد"
            value={filters.SupplierName}
            onChange={(e) => updateFilters({ SupplierName: e.target.value })}
          />
          <input type="date" value={filters.From} onChange={(e) => updateFilters({ From: e.target.value })} title="من تاريخ" />
          <input type="date" value={filters.To} onChange={(e) => updateFilters({ To: e.target.value })} title="إلى تاريخ" />
          <input
            type="text"
            placeholder="بحث..."
            value={filters.SearchTerm}
            onChange={(e) => updateFilters({ SearchTerm: e.target.value })}
          />
        </div>

        <button className={styles.addBtn} onClick={openAddModal}>+ إضافة معاملة مورد</button>
      </div>

      <SupplierTable items={items} loading={loading} onEdit={openEditModal} onDelete={requestDelete} />

      {pagination.totalPages > 1 && (
        <div className={styles.pagination}>
          <button disabled={!pagination.hasPreviousPage} onClick={() => goToPage(pagination.currentPage - 1)}>السابق</button>
          <span>صفحة {pagination.currentPage} من {pagination.totalPages}</span>
          <button disabled={!pagination.hasNextPage} onClick={() => goToPage(pagination.currentPage + 1)}>التالي</button>
        </div>
      )}

      <SupplierFormModal isOpen={modalOpen} onClose={closeModal} onSubmit={handleSubmit} initialData={selectedItem} />

      <ConfirmDialog
        isOpen={!!itemToDelete}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من حذف معاملة "${itemToDelete?.itemName}" الخاصة بـ "${itemToDelete?.supplierName}"؟`}
        loading={deleting}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
  );
};

export default SupplierTab;